/** @jsxImportSource @emotion/react */
import { jsx } from '@emotion/react'
import React from 'react';
import { suomifiDesignTokens as tokens } from "suomifi-ui-components";
import { ButtonLink } from "./InputStyles";
import { useTranslation } from 'react-i18next';
import logo from '../../assets/Remppa_Vasara.png';

const Header: React.FC = () => {

  const { t, i18n } = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
      <header>
        <div style={{
          display: 'flex',
          fontWeight: 600,
          justifyContent: "space-between",
        }}>
          <div style={{
            color: tokens.colors.brandBase,
            fontSize: '28px',
          }}>
            <img src={logo} alt='Logo' style={{height: "100px"}}/>
          </div>

          <div style={{
            display: 'flex',
            textAlign: "right",
            lineHeight: 1
          }}>
            <div style={{
              display: 'flex'
            }}>
              <ButtonLink
                  style={{textTransform: "uppercase", fontSize: '22px', margin: `0 ${tokens.spacing.xxs}`}}
                  onClick={() => changeLanguage('fi') }>
                FI
              </ButtonLink>
              <ButtonLink
                  style={{textTransform: "uppercase", fontSize: '22px', margin: `0 ${tokens.spacing.xxs}`}}
                  onClick={() => changeLanguage('en') }>
                EN
              </ButtonLink>
            </div>
          </div>
        </div>
      </header>
  );
};

export default Header;
